"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTheme = exports.preparePrimaryColor = exports.stripComplementaryPalette = exports.prepareBaseColors = exports.prepareComplementaryPalette = void 0;
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var complementaryPalette_1 = require("../complementaryPalette");
/**
 * Minimum contrast ratio n:1 recommended by W3C
 * https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html
 */
var MIN_CONTRAST_RATIO = 3;
var DEFAULT_BACKGROUND_COLOR = "#fff";
exports.prepareComplementaryPalette = function (theme) {
    var _a;
    if ((_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.complementary) {
        return tslib_1.__assign(tslib_1.__assign({}, theme), { palette: tslib_1.__assign(tslib_1.__assign({}, theme.palette), { complementary: complementaryPalette_1.getComplementaryPalette(theme.palette.complementary) }) });
    }
    return theme;
};
exports.prepareBaseColors = function (theme) {
    var _a;
    var defaultPrimary = "#14b2e2";
    var defaultSuccess = "#00c18d";
    var defaultError = "#e54d42";
    var defaultWarning = "#fada23";
    if ((_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.complementary) {
        return tslib_1.__assign(tslib_1.__assign({}, theme), { palette: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, theme.palette), (theme.palette.primary ? {} : { primary: { base: defaultPrimary } })), (theme.palette.success ? {} : { success: { base: defaultSuccess } })), (theme.palette.error ? {} : { error: { base: defaultError } })), (theme.palette.warning ? {} : { warning: { base: defaultWarning } })) });
    }
    return theme;
};
exports.stripComplementaryPalette = function (theme) {
    var _a;
    var strippedTheme = tslib_1.__assign({}, theme);
    ((_a = strippedTheme === null || strippedTheme === void 0 ? void 0 : strippedTheme.palette) === null || _a === void 0 ? void 0 : _a.complementary) && delete strippedTheme.palette.complementary;
    (strippedTheme === null || strippedTheme === void 0 ? void 0 : strippedTheme.chart) && delete strippedTheme.chart;
    (strippedTheme === null || strippedTheme === void 0 ? void 0 : strippedTheme.table) && delete strippedTheme.table;
    return strippedTheme;
};
exports.preparePrimaryColor = function (theme) {
    var _a, _b, _c;
    var primaryColor = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.primary) === null || _b === void 0 ? void 0 : _b.base;
    if (!((_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.complementary) || !primaryColor) {
        return theme;
    }
    var contrastPrimaryColor = primaryColor;
    while (polished_1.getContrast(contrastPrimaryColor, DEFAULT_BACKGROUND_COLOR) < MIN_CONTRAST_RATIO) {
        contrastPrimaryColor = polished_1.shade(0.05, contrastPrimaryColor);
    }
    return tslib_1.__assign(tslib_1.__assign({}, theme), { palette: tslib_1.__assign(tslib_1.__assign({}, theme.palette), { primary: tslib_1.__assign(tslib_1.__assign({}, theme.palette.primary), { base: contrastPrimaryColor }) }) });
};
exports.prepareTheme = function (theme, enableComplementaryPalette) {
    if (enableComplementaryPalette === void 0) { enableComplementaryPalette = true; }
    if (!enableComplementaryPalette) {
        var themeWithContrastPrimaryColor = exports.preparePrimaryColor(theme);
        return exports.stripComplementaryPalette(themeWithContrastPrimaryColor);
    }
    var themeWithComplementaryPalette = exports.prepareComplementaryPalette(theme);
    return exports.prepareBaseColors(themeWithComplementaryPalette);
};
//# sourceMappingURL=prepareTheme.js.map